import React from 'react';
import GameListHeader from '@/pages/games/list/GameListHeader';
import EmptyGamesPlaceholder from '@/pages/games/EmptyGamesPlaceholder';
import { useIntl } from 'react-intl';

import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GameShows from '@/pages/games/lobby/lobby-sections-streamlines/GameShows';
import Blackjack from '@/pages/games/lobby/lobby-sections-streamlines/Blackjack';
import Baccarat from '@/pages/games/lobby/lobby-sections-streamlines/Baccarat';
import Roulette from '@/pages/games/lobby/lobby-sections-streamlines/Roulette';
import Poker from '@/pages/games/lobby/lobby-sections-streamlines/Poker';
import AsianGames from '@/pages/games/lobby/lobby-sections-streamlines/AsianGames';
import { useSelector } from 'react-redux';
import { selectGamesLoading, selectLiveCasinoGames } from '@/store/games/selectors';

const CategoryLiveCasinoGames = () => {
  const intl = useIntl();
  const header = intl.formatMessage({ id: `games.categories.live-casino` });
  const subheader = intl.formatMessage({ id: `games.categories.live-casino.info` });

  const games = useSelector(selectLiveCasinoGames);
  const loading = useSelector(selectGamesLoading);

  if (!games || games.length === 0) return null;

  return (
    <section className="py-6 md:pt-16 px-[16px] 2xl:px-0 max-w-[1400px] mx-auto">
      {header && (
        <GameListHeader
          header={header}
          subheader={subheader}
          games={games}
          count={games.length}
          gamesLoading={loading}
        />
      )}
      {games && games.length === 0 ? (
        <EmptyGamesPlaceholder category={BffGamesCategory.LiveCasino} />
      ) : (
        <>
          <div className="py-3 md:py-8 xl:py-16 flex flex-col gap-8 sm:gap-12 md:gap-20 max-w-[1400px] mx-auto">
            <GameShows />
            <Blackjack />
            <Baccarat />
            <Roulette />
            <Poker />
            <AsianGames />
          </div>
        </>
      )}
    </section>
  );
};

export default CategoryLiveCasinoGames;
